import { render, staticRenderFns } from "./inputi.vue?vue&type=template&id=0a739e8a&scoped=true&"
import script from "./inputi.vue?vue&type=script&lang=js&"
export * from "./inputi.vue?vue&type=script&lang=js&"
import style0 from "./inputi.vue?vue&type=style&index=0&id=0a739e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a739e8a",
  null
  
)

export default component.exports